import { HardHat, HouseLine, ChartLineUp, Handshake, ShieldPlus, Bank } from "@phosphor-icons/react";

export const SOLUTIONS = [
  {
    key: "contractors",
    icon: HardHat,
    audience: "For Contractors & Trade Owners",
    title: "Protect the business you built.",
    tagline:
      "Key-person protection and funded buy-sell agreements that keep ownership — and cash flow — where they belong.",
    image:
      "https://images.pexels.com/photos/30640160/pexels-photo-30640160.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1000",
    points: [
      { icon: ShieldPlus, name: "Key-Person Protection", desc: "Insure the owner or lead earner whose absence would stall the business, so operations survive the transition." },
      { icon: Handshake, name: "Buy-Sell Funding", desc: "Life insurance funds a pre-agreed buyout, giving a partner's family fair value in cash and keeping control with the survivor." },
    ],
    intro:
      "If your business depends on one or two people, an unexpected loss can put everything you've built at risk. We design coverage that keeps the doors open and ownership intact.",
    sections: [
      { h: "Why key-person coverage matters", p: "Lenders, bonding companies, and partners all rely on your continuity. A key-person policy provides tax-advantaged cash to cover lost revenue, recruit a replacement, and reassure creditors while the business stabilizes." },
      { h: "How buy-sell funding works", p: "Each owner is insured so that, on a death or disability, the death benefit buys out the departing owner's share at a value you agree on today. The family receives fair market value in cash; the surviving owner avoids taking on an unintended partner." },
    ],
  },
  {
    key: "families",
    icon: HouseLine,
    audience: "For Families & Homeowners",
    title: "Keep your family in their home.",
    tagline:
      "Mortgage protection and living benefits that pay out when life takes an unexpected turn — not just at death.",
    image:
      "https://images.unsplash.com/photo-1760084836111-b384c6d32104?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    points: [
      { icon: HouseLine, name: "Mortgage Protection", desc: "Coverage sized to your remaining balance so your family can stay in the home if income disappears." },
      { icon: ShieldPlus, name: "Living Benefits", desc: "Critical & chronic illness riders let you access your benefit early for medical bills and lost income." },
    ],
    intro:
      "Your mortgage is likely your largest obligation. We make sure it — and your family's day-to-day life — is protected against the unexpected, with policies that work while you're still here.",
    sections: [
      { h: "Mortgage protection, done right", p: "Rather than a bank's declining-benefit policy, we typically use a level term policy you own and control — often cheaper, and the payout goes to your family, not the lender, to use however they need." },
      { h: "Living benefits explained", p: "Modern policies can include accelerated death benefit riders. A qualifying critical, chronic, or terminal diagnosis lets you draw on your own benefit early — tax-advantaged — to cover treatment and keep the mortgage current while you recover." },
    ],
  },
  {
    key: "wealth",
    icon: ChartLineUp,
    audience: "For Wealth Accumulation",
    title: "Grow tax-advantaged cash value.",
    tagline:
      "Indexed Universal Life and annuities that pair protection with a floor-protected, tax-advantaged way to build and access cash.",
    image:
      "https://images.pexels.com/photos/12013184/pexels-photo-12013184.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1000",
    points: [
      { icon: ChartLineUp, name: "Indexed Universal Life (IUL)", desc: "Cash value linked to a market index with a 0% floor, plus tax-deferred growth and tax-free policy loans." },
      { icon: Bank, name: "Annuities", desc: "Turn a lump sum into guaranteed, predictable income you can't outlive in retirement." },
    ],
    intro:
      "Protection and accumulation don't have to be separate. We structure strategies that guard against market losses while building a tax-advantaged pool of cash you can use in retirement.",
    sections: [
      { h: "The IUL floor-and-cap advantage", p: "Your cash value earns interest tied to an index like the S&P 500, subject to a cap in strong years and a floor (usually 0%) in down years — so a bad market never erodes your accumulated value." },
      { h: "Why add an annuity", p: "Annuities convert savings into guaranteed lifetime income, complementing Social Security and retirement accounts. Together with an IUL, they form a tax-aware foundation for the decades after work." },
    ],
  },
];

export const solutionByKey = (key) => SOLUTIONS.find((s) => s.key === key);
